<template>
  <page layoutClass="manage-leaderboards">
    <b-row v-if="leaderboard">
      <b-col cols="12" md="7">
        <b-card class="shadow">

        </b-card>
      </b-col>
      <b-col cols="12" md="5">
        Bar
      </b-col>
      <b-col cols="12">
        <b-card class="shadow mt-3 p-0">
          <code><pre>{{ JSON.stringify(leaderboard, null, 2) }}</pre></code>
        </b-card>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import formatDate from 'date-fns/format';
import ManageLeaderboardQuery from '@/graphql/queries/ManageLeaderboard.gql';

export default {
  props: {
    leaderboardID: String,
  },
  components: {
    Page,
  },
  data: () => ({
    form: {},
  }),
  apollo: {
    leaderboard: {
      query: ManageLeaderboardQuery,
      variables() {
        const { leaderboardID } = this;
        return { leaderboardID };
      },
      update: ({ company: { leaderboard } }) => leaderboard,
      fetchPolicy: 'network-only',
      skip() {
        return this.isNew;
      },
    },
  },
  metaInfo: {
    title: 'Manage Leaderboards',
  },
  computed: {
    isNew() {
      return this.leaderboardID === 'new';
    },
  },
  methods: {
    formatDate,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Recruiter/ManageLeaderboard.vue